import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Tnews } from "../type/news";
import { postDataPages } from "../service/newsServise";
import { showMessage } from "../utls/message";

export interface newsSlice {
    newsPage: Tnews[],
    totalRows: number;
    pageNo: number;
    pageSize: number;
}

const initialState: newsSlice = {
    newsPage: [],
    totalRows: 0,
    pageNo: 0,
    pageSize: 10
}

export const postDataPage = createAsyncThunk("news/filter",
    async (data: any) => {
        const response = await postDataPages(data);
        if (response?.code === 200 && !response.error) {
            return response.data;
        } else {
            showMessage(`${response?.code} ${response?.message}`, "danger");
            return initialState;
        }
    }
);

const newsSlice = createSlice({
    name: "news",
    initialState,
    reducers: {
        setPageNo: (state, action) => {
            state.pageNo = action.payload;
        },
        setPageSize: (state, action) => {
            state.pageSize = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(postDataPage.fulfilled, (state, action) => {
                if (action.payload.content) {
                    state.newsPage = action.payload.content;
                    state.totalRows = action.payload.totalElements;
                } else {
                    state.newsPage = [];
                    state.totalRows = 0;
                }
            });
    }
});

export const { setPageNo, setPageSize } = newsSlice.actions;
export default newsSlice.reducer;
